import * as React from 'react';

import * as Schema from 'nutshell-core/schema';
import type {EntityListType, FilterObject} from 'nutshell-core/types';

import {CloseButton} from 'shells/button/close-button/close-button';

import {FormAccountHierarchy} from './forms/account-hierarchy';
import {FormNewRelationship} from './forms/new-relationship';
import {FormRelationship} from './forms/relationship';
import {NegativeFilter} from './negative-filter';

import styles from './filter-section.module.css';

type MultipleFilterSectionProps = {
    field: Schema.EnumField | Schema.RelationshipField | Schema.StageField | Schema.HierarchyField;
    filter: FilterObject;
    entityType: EntityListType;
    sectionIndex: number;
    totalSections: number;
    excludedOptions: any[];
    allowNegation: boolean;
    onFilterChange: (newValue: string) => any;
    onNegationChange: (newValue: boolean) => any;
    onFilterNegationChange: (value: string, isNot: boolean) => any;
    onClearFilter: () => any;
    onRemoveFilter: () => any;
    allowAny?: boolean;
};

// @ts-expect-error
function shouldAllowAny(field, allowNegation) {
    // to support existing behavior, we default to true if allowAny is not defined and rely on allowNegation
    const allowAny = field.allowAny !== undefined ? field.allowAny : true;

    return Boolean(allowAny) && !allowNegation;
}

export class MultipleFilterSection extends React.PureComponent<MultipleFilterSectionProps> {
    render() {
        const {field} = this.props;

        const isNot =
            typeof this.props.filter.isNot === 'string'
                ? this.props.filter.isNot === 'true'
                : this.props.filter.isNot;

        const getForm = () => {
            if (field.type === 'hierarchy') {
                return (
                    <FormAccountHierarchy
                        {...this.props.field}
                        name={`${this.props.field.name}-${this.props.sectionIndex}`}
                        value={this.props.filter.data}
                        isNot={isNot}
                        // @ts-expect-error
                        excludedOptions={this.props.excludedOptions}
                        entityType={this.props.entityType}
                        onChange={this.props.onFilterChange}
                        onClearValue={this.props.onClearFilter}
                        onFilterNegationChange={this.props.onFilterNegationChange}
                        hierarchyTypeFilter={`${this.props.field.name}`}
                    />
                );
            } else if (field.isNewDesign) {
                return (
                    <FormNewRelationship
                        {...this.props.field}
                        name={`${this.props.field.name}-${this.props.sectionIndex}`}
                        value={this.props.filter.data}
                        isNot={isNot}
                        excludedOptions={this.props.excludedOptions}
                        entityType={this.props.entityType}
                        onChange={this.props.onFilterChange}
                        onClearValue={this.props.onClearFilter}
                        onFilterNegationChange={this.props.onFilterNegationChange}
                        // @ts-expect-error enum/stage use `enum` on schema; FormNewRelationship expects `options`
                        options={
                            // @ts-expect-error
                            this.props.field.type === 'enum' || this.props.field.type === 'stage'
                                ? this.props.field.enum
                                : undefined
                        }
                    />
                );
            } else {
                return (
                    <FormRelationship
                        {...this.props.field}
                        // @ts-expect-error
                        options={
                            // @ts-expect-error
                            this.props.field.type === 'enum' || this.props.field.type === 'stage'
                                ? this.props.field.enum
                                : undefined
                        }
                        value={this.props.filter.data}
                        allowAny={shouldAllowAny(this.props.field, this.props.allowNegation)}
                        excludedOptions={this.props.excludedOptions}
                        entityType={this.props.entityType}
                        onChange={this.props.onFilterChange}
                        onClearValue={this.props.onClearFilter}
                    />
                );
            }
        };

        return (
            <div className={this.props.totalSections > 1 ? styles['form-multiple'] : styles.form}>
                <CloseButton
                    className={styles['close-button']}
                    onClick={this.props.onRemoveFilter}
                    size={8}
                />
                {this.props.allowNegation &&
                field.name !== 'status' &&
                field.type !== 'hierarchy' &&
                !field.isNewDesign ? (
                    <NegativeFilter
                        name={`${this.props.field.name}-negation-${this.props.sectionIndex}`}
                        isNot={isNot}
                        onChange={this.props.onNegationChange}
                    />
                ) : undefined}
                {getForm()}
            </div>
        );
    }
}
